<template>
  <MembershipPage
    title="You're Taking A Style Break">
    <template #aboveBox>
      <div class="d-flex flex-column gap-sm">
        <h4>Here's What To Expect</h4>
        <h6>
          Your account will be paused from {{ pauseDates.startDate }} to {{ pauseDates.endDate }}
        </h6>
        <p>We'll remind you by email a few days before your subscription restarts. If you're ready to return sooner, you can restart your membership anytime.</p>
      </div>
    </template>
    <template #boxContent>
      <div class="d-flex flex-column gap-xl ">
        <div class="d-flex flex-column gap-sm align-items-center">
          <p>Please return all items in your prepaid return bag by {{ pauseDates.startDate }} to avoid being charged for outstanding items.</p>
          <BaseButton
            text="Print New Label"
            :to="printReturnLabelLink"/>
        </div>
        <div class="d-flex flex-column gap-sm align-items-center">
          <b>Oops, didn't mean to pause?</b>
          <p>No worries, contact our support team to edit your membership.</p>
          <BaseButton
            text="Email Customer Support"
            :to="`mailto:hi@armoire.style?subject=${encodeURIComponent('Membership Inquiry')}`"/>
        </div>
      </div>
    </template>
    <template #belowBox>
      <BaseButton
        class="align-self-center"
        variant="text-link"
        text="Go to My Account"
        :to="{ name: 'account' }"/>
    </template>
  </MembershipPage>
</template>

<script setup>
import MembershipPage from '@/components/account/membership/new/MembershipPage.vue'
import { onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAccountStore } from '@/stores/account.js'
import { useClientStore } from '@shared/stores/client.js'
import { usePauseCancel } from '@/composables/pauseCancel.js'
import { useReturnCarrier } from '@/composables/returnCarrier.js'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import useAnalytics from '@shared/composables/analytics.js'

const accountStore = useAccountStore()
const { pauseSubscription } = accountStore
const {
  pauseDates,
  getBilling,
} = usePauseCancel()
const { trackPageViewEvent } = useAnalytics()

const { printReturnLabelLink } = useReturnCarrier()
const clientStore = useClientStore()
const { membershipDetails } = storeToRefs(clientStore)

const canPause = computed(() => {
  return membershipDetails.value?.selfServicePauseEligible
})

onMounted(async () => {
  trackPageViewEvent('Pause Membership')
  await getBilling()
  if (canPause.value) {
    await pauseSubscription({ months: 1 })
  }
})

</script>
